import { SsMount } from 'src/js/dom/mount.js';
import { SsPage } from 'src/js/dom/page.js';
import { SsLooks } from 'src/js/dom/looks.js';
import { SsGallery } from 'src/js/dom/gallery.js';
import { getHead } from 'src/js/lib/url.js';

const head = getHead();
let firstTime = true;

export const gallery = new SsGallery(
  document.getElementById( 'ss-gallery' )
);

export class SsSubPage extends SsPage {
  constructor ( elm ) {
    super( elm );
    this.titleElm = new SsMount(
      document.getElementById( 'ss-page-sub' )
    );
    this.looksElm = new SsMount(
      document.getElementById( 'ss-sub-page-looks' )
    );
    this.looks = {};
    this.curLooks = undefined;
  }

  setTitle ( elms ) {
    elms.forEach( elm => {
      this.titleElm.elm.appendChild( elm[ 0 ] );
    });
  }

  reset () {
    this.offGallery();
    this.titleElm.$.empty();
    this.looksElm.$.empty();
  }

  async loadLooks ( id, path, num ) {
    // Display looks on sub page first time
    if ( typeof this.looks[ id ] === 'undefined' )
    {
      this.looks[ id ] = new SsLooks( id );
      this.looksElm.$.append( this.looks[ id ].makeDom( path, num ) );
      this.looks[ id ].lazyLoad();
    }
    // Display looks after first time
    else
    {
      this.looksElm.$.append( this.looks[ id ].getDom() );
    }
    // Load cover images for each of look in background
    await gallery.load( id, path, num );
    // set current shown looks
    this.curLooks = this.looks[ id ];
    // Watch for gallery events
    this.onGallery();
    // Check url hash
    if ( firstTime && head && Number( head ) <= num ) {
      firstTime = false;
      window.setTimeout( () => {
        gallery.open( Number( head ) );
      }, 1000 );
    }
    else {
      this.curLooks.onClicks();
    }
  }

  onGallery () {
    const looks = this.curLooks;
    gallery.on( 'open', looks.offClicks.bind( looks ) );
    gallery.on( 'close', looks.onClicks.bind( looks ) );
  }

  offGallery () {
    gallery.off( 'open' );
    gallery.off( 'close' );
  }
}
